<template>
    <div class="join-page-wrapper">
        <div class="col-md-12 margin-bottom-20">
            <div class="join-section clearfix margin-top-40">
                <div class="col-md-12">
                    <datepicker v-model="dateVal"  :format="dateFormat" :clear-button="isClear">
                    </datepicker>
                    <h1>{{dateVal}}</h1>
                    <h1>Join Tone Today</h1>
                    <p>
                        Lorem Ipsum is simply dummy text of the printing <br>
                        and typesetting industry
                    </p>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 margin-top-30">
                    <div class="chat-button">
                        <div class="text-center"><button class="btn btn-danger btn-lg" type="button">Start Your 30-Day's Trial Now</button></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 margin-top-20">
                    <div class="chat-button">
                        <div class="text-center"><button class="btn btn-danger btn-transparent btn-lg" type="button">Watch Video</button></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 margin-top-40">
            <div class="blog-section white-bg clearfix">
                <div class="row">
                    <div class="col-md-7">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <div class="jumbotron">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="text-left">
                            <h3>Career</h3>
                            <p>
                                Lorem ipsum dolor sit amet,
                                consectetur adipiscing elit,
                                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            </p>
                            <div class="blog-button">
                                <button class="btn btn-danger btn-lg" type="button">Learn More</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row margin-top-30">
                    <div class="col-md-7 alternate-content">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <div class="jumbotron">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="text-left alternate-content-text">
                            <h3>Inspiration</h3>
                            <p>
                                Lorem ipsum dolor sit amet,
                                consectetur adipiscing elit,
                                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            </p>
                            <div class="blog-button">
                                <button class="btn btn-danger btn-lg" type="button">Learn More</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row margin-top-30">
                    <div class="col-md-7">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <div class="jumbotron">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="text-left">
                            <h3>Mind Body</h3>
                            <p>
                                Lorem ipsum dolor sit amet,
                                consectetur adipiscing elit,
                                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            </p>
                            <div class="blog-button">
                                <button class="btn btn-danger btn-lg" type="button">Learn More</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row margin-top-30">
                    <div class="col-md-7 alternate-content">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <div class="jumbotron">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="text-left alternate-content-text">
                            <h3>Live Chat With Experts</h3>
                            <p>
                                Lorem ipsum dolor sit amet,
                                consectetur adipiscing elit,
                                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            </p>
                            <div class="blog-button">
                                <button class="btn btn-danger btn-lg" type="button">Learn More</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 margin-bottom-40">
            <div class="goods-section clearfix">
                <div class="col-md-12">
                    <h1>Clicks For Goods</h1>
                    <p>
                        Lorem Ipsum is simply dummy text of the <br>
                        printing and typesetting industry
                    </p>
                    <div class="margin-top-40">
                        <div class="text-center"><button class="btn btn-danger btn-lg" type="button">Learn More</button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { input, spinner, accordion, panel, alert, dropdown, radio, checkbox, tabs, tab, buttonGroup, datepicker } from 'vue-strap'
    import VuePassword from 'vue-password'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'accordion': accordion,
            'panel': panel,
            alert,
            dropdown,
            radio,
            VuePassword,
            checkbox,
            tabs,
            tab,
            buttonGroup,
            datepicker
        },
        name: 'join',
        data: function () {
            return {
                dateVal: '',
                dateFormat: 'MM/dd/yyyy',
                isClear: true,
                title: 'Enter Delivery Date'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Join.vue?630389b0